import { Div, Text } from "atomize"
import { useContext } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import { schoolContext } from "../providers/school.provider"
import { sharedDataContext } from "../providers/sharedData.provider"
import { lessonTypeHasCourt } from "../utils/func.utils"

// Il campo di una lezione in una pastiglia sola, per la settimana: il numero
// e il pallino della superficie, come nella riga del campo della scheda.
// Luci, riscaldamento e chi paga stanno nella scheda: qui si cerca solo dove.
function WeekCourtPill({ lesson, compact = false }) {
	const { getSelectedSchool } = useContext(schoolContext)
	const { getLessonType } = useContext(sharedDataContext)

	const school = getSelectedSchool()
	const court = lesson.court
	// le lezioni vecchie salvavano il numero e basta, senza sport né superficie
	const courtNumber = court?.courtNumber ?? court
	const courtsSport = court?.courtsSport ?? lesson.sportID
	if (!court || !school || !lessonTypeHasCourt(getLessonType(lesson.lessonType))) return null

	const surfaceColor =
		theme.colors[school.courts?.[courtsSport]?.[courtNumber]?.surfaceType] ??
		theme.colors.gunmetal_light

	return (
		<Div
			data-morph="court"
			d="flex"
			align="center"
			p={compact ? "0 0.35rem" : "0.1rem 0.5rem"}
			rounded="10px"
			bg={theme.colors.background}
			style={{ gap: "0.25rem", flexShrink: 0 }}>
			<Text
				textSize={compact ? "tiny" : "caption"}
				textWeight="bold"
				textColor={theme.colors.gunmetal}
				style={{ whiteSpace: "nowrap" }}>
				{compact ? courtNumber : `Campo ${courtNumber}`}
			</Text>
			<FontAwesomeIcon icon={faCircle} color={surfaceColor} size="xs" />
		</Div>
	)
}

export default WeekCourtPill
